// Self-hosted browser bundle: the npm entry pulls node:fs/node:https, which webpack 5 will not bundle.
const PPTX_SRC = "/vendor/pptxgen.bundle.js";
let pptxLoading = null;
const loadPptxGen = () => {
  if (window.PptxGenJS) return Promise.resolve(window.PptxGenJS);
  if (!pptxLoading) {
    pptxLoading = new Promise((resolve, reject) => {
      const el = document.createElement("script");
      el.src = PPTX_SRC;
      el.onload = () => (window.PptxGenJS ? resolve(window.PptxGenJS) : reject(new Error("pptxgenjs failed to load")));
      el.onerror = () => reject(new Error("pptxgenjs failed to load"));
      document.head.appendChild(el);
    });
  }
  return pptxLoading;
};

// Editable PowerPoint built by walking the rendered pitchbook DOM, so the deck you see and the deck
// you download can never disagree. Every element becomes a real text box or table you can retype.
const INK = "101C2E", INK2 = "3D4C63", INK3 = "77849A", PAPER = "FBFAF7", ACCENT = "C6F24E", LINE = "DFDCD3";
const FONT = "Calibri";
let PPTX = null;   // set when an export starts, so block builders can add native charts
const W = 13.333, Hh = 7.5, PADX = 0.62;
const COL = (W - PADX * 2 - 0.5) / 2;

const txt = (el) => (el ? el.textContent.replace(/\s+/g, " ").trim() : "");
const all = (root, sel) => Array.from(root.querySelectorAll(sel));
const kids = (root, sel) => Array.from(root.children).filter((c) => c.matches(sel));
// Rough line-count estimate so stacked blocks don't collide.
const lines = (s, chars) => Math.max(1, Math.ceil((s || "").length / chars));

function addRows(slide, el, x, y, w) {
  const cells = Array.from(el.children);
  let cy = y;
  for (let i = 0; i < cells.length; i += 2) {
    const label = txt(cells[i]), value = txt(cells[i + 1]);
    const h = 0.26 * lines(label, Math.round(w * 13));
    slide.addText(label, { x, y: cy, w: w * 0.6, h, fontSize: 10, color: INK2, fontFace: FONT, valign: "top" });
    slide.addText(value, { x: x + w * 0.6, y: cy, w: w * 0.4, h, fontSize: 10, bold: true, color: INK, fontFace: FONT, align: "right", valign: "top" });
    cy += h + 0.05;
    slide.addShape("line", { x, y: cy - 0.04, w, h: 0, line: { color: LINE, width: 0.6 } });
  }
  return cy + 0.12;
}

function addCards(slide, el, x, y, w) {
  const items = kids(el, "div");
  const cw = (w - 0.28) / 2;
  let cy = y;
  items.forEach((it, i) => {
    const cx = x + (i % 2) * (cw + 0.28);
    const title = txt(it.querySelector("b")), body = txt(it.querySelector("span"));
    const h = 0.22 + 0.19 * lines(body, Math.round(cw * 15));
    if (i % 2 === 0 && i) cy += h + 0.16;
    slide.addShape("rect", { x: cx, y: cy, w: 0.035, h, fill: { color: ACCENT } });
    slide.addText([
      { text: title, options: { bold: true, fontSize: 10, color: INK, breakLine: true } },
      { text: body, options: { fontSize: 9, color: INK2 } },
    ], { x: cx + 0.14, y: cy, w: cw - 0.14, h, fontFace: FONT, valign: "top", lineSpacingMultiple: 0.92 });
  });
  const rows = Math.ceil(items.length / 2);
  return cy + 0.9 * rows + 0.1;
}

function addBullets(slide, el, x, y, w, numbered) {
  const items = all(el, "li").map((li) => txt(li));
  let cy = y;
  items.forEach((t, i) => {
    const h = 0.2 * lines(t, Math.round(w * 15));
    slide.addText(`${numbered ? `${i + 1}.` : "—"}  ${t.replace(/^(—|\d+\.)\s*/, "")}`,
      { x, y: cy, w, h, fontSize: 9.5, color: INK2, fontFace: FONT, valign: "top", lineSpacingMultiple: 0.95 });
    cy += h + 0.07;
  });
  return cy + 0.08;
}

function addSteps(slide, el, x, y, w) {
  const items = all(el, "li");
  let cy = y;
  items.forEach((li, i) => {
    const title = txt(li.querySelector("b")), body = txt(li.querySelector("span"));
    const h = 0.22 + 0.19 * lines(body, Math.round(w * 17));
    slide.addShape("ellipse", { x, y: cy + 0.02, w: 0.22, h: 0.22, fill: { color: INK } });
    slide.addText(String(i + 1), { x, y: cy + 0.02, w: 0.22, h: 0.22, fontSize: 8, bold: true, color: PAPER, align: "center", valign: "middle", fontFace: FONT });
    slide.addText([
      { text: title, options: { bold: true, fontSize: 10, color: INK, breakLine: true } },
      { text: body, options: { fontSize: 9, color: INK2 } },
    ], { x: x + 0.32, y: cy, w: w - 0.32, h, fontFace: FONT, valign: "top", lineSpacingMultiple: 0.92 });
    cy += h + 0.12;
  });
  return cy;
}

function addTimeline(slide, el, x, y, w) {
  const items = all(el, "li");
  let cy = y;
  items.forEach((li) => {
    const title = txt(li.querySelector("b")), body = txt(li.querySelector("span"));
    const h = 0.22 + 0.19 * lines(body, Math.round(w * 13));
    slide.addShape("rect", { x, y: cy, w: 0.035, h, fill: { color: ACCENT } });
    slide.addText(title, { x: x + 0.14, y: cy, w: 1.9, h: 0.24, fontSize: 10, bold: true, color: INK, fontFace: FONT, valign: "top" });
    slide.addText(body, { x: x + 2.1, y: cy, w: w - 2.2, h, fontSize: 9, color: INK2, fontFace: FONT, valign: "top", lineSpacingMultiple: 0.92 });
    cy += h + 0.14;
  });
  return cy;
}

function addStats(slide, el, x, y, w) {
  let cy = y;
  kids(el, "div").forEach((d) => {
    const big = txt(d.querySelector("b")), body = txt(d.querySelector("span"));
    const h = Math.max(0.5, 0.19 * lines(body, Math.round((w - 1.3) * 15)));
    slide.addText(big, { x, y: cy, w: 1.25, h: 0.5, fontSize: 24, bold: true, color: INK, fontFace: FONT, valign: "top" });
    slide.addText(body, { x: x + 1.35, y: cy + 0.04, w: w - 1.35, h, fontSize: 9.5, color: INK2, fontFace: FONT, valign: "top", lineSpacingMultiple: 0.95 });
    cy += Math.max(0.62, h + 0.16);
  });
  return cy;
}

function addArb(slide, el, x, y, w) {
  const label = txt(el.querySelector("span")), big = txt(el.querySelector("b")), sub = txt(el.querySelector("i"));
  slide.addShape("rect", { x, y, w, h: 2.4, fill: { color: INK } });
  slide.addText(label.toUpperCase(), { x: x + 0.3, y: y + 0.3, w: w - 0.6, h: 0.25, fontSize: 9, color: "8A97AC", charSpacing: 2, fontFace: FONT });
  slide.addText(big, { x: x + 0.3, y: y + 0.6, w: w - 0.6, h: 1.1, fontSize: 54, bold: true, color: ACCENT, fontFace: FONT });
  slide.addText(sub, { x: x + 0.3, y: y + 1.75, w: w - 0.6, h: 0.4, fontSize: 10, color: "C9D2DF", fontFace: FONT });
  return y + 2.6;
}

function addNote(slide, el, x, y, w) {
  const label = txt(el.querySelector("span")), body = txt(el.querySelector("p"));
  const h = 0.42 + 0.19 * lines(body, Math.round(w * 17));
  slide.addShape("rect", { x, y, w, h, fill: { color: "FFFFFF" }, line: { color: LINE, width: 0.6 } });
  slide.addShape("rect", { x, y, w: 0.04, h, fill: { color: ACCENT } });
  slide.addText(label.toUpperCase(), { x: x + 0.16, y: y + 0.06, w: w - 0.3, h: 0.2, fontSize: 8, color: INK3, charSpacing: 1.6, fontFace: FONT });
  slide.addText(body, { x: x + 0.16, y: y + 0.28, w: w - 0.3, h: h - 0.32, fontSize: 9.5, color: INK2, fontFace: FONT, valign: "top", lineSpacingMultiple: 0.95 });
  return y + h + 0.14;
}

function addTable(slide, el, x, y, w) {
  const head = all(el, "thead th").map((th) => txt(th));
  const bodyRows = all(el, "tbody tr");
  const cols = Math.max(head.length, bodyRows[0] ? bodyRows[0].children.length : 1);
  const rows = [];
  if (head.length) {
    rows.push(head.map((h, i) => ({ text: h, options: { bold: true, color: INK3, fontSize: 8, align: i ? "right" : "left", charSpacing: 1.2 } })));
  }
  bodyRows.forEach((tr) => {
    const total = tr.classList.contains("tot") || tr.classList.contains("total");
    rows.push(Array.from(tr.children).map((td, i) => ({
      text: txt(td),
      options: { fontSize: 9, bold: total, color: total ? INK : INK2, align: td.classList.contains("num") || (i && head.length) ? "right" : "left" },
    })));
  });
  if (!rows.length) return y;
  const firstW = cols > 3 ? w * 0.3 : w * 0.46;
  const colW = [firstW, ...Array(cols - 1).fill((w - firstW) / Math.max(1, cols - 1))];
  slide.addTable(rows, { x, y, w, colW, border: { type: "solid", pt: 0.4, color: LINE }, fontFace: FONT, valign: "middle", rowH: 0.26, autoPage: false });
  return y + 0.3 * rows.length + 0.14;
}

function addToc(slide, el, x, y, w) {
  const items = all(el, "li");
  const half = Math.ceil(items.length / 2);
  items.forEach((li, i) => {
    const col = i < half ? 0 : 1;
    const row = i % half;
    const cx = x + col * (w / 2 + 0.2);
    const cy = y + row * 0.62;
    slide.addText(txt(li.querySelector(".pb-toc-n")), { x: cx, y: cy, w: 0.4, h: 0.22, fontSize: 9, bold: true, color: "8FBF2E", fontFace: FONT });
    slide.addText(txt(li.querySelector("b")), { x: cx + 0.45, y: cy - 0.02, w: w / 2 - 0.6, h: 0.24, fontSize: 11, bold: true, color: INK, fontFace: FONT });
    slide.addText(txt(li.querySelector("i")), { x: cx + 0.45, y: cy + 0.2, w: w / 2 - 0.6, h: 0.22, fontSize: 8.5, color: INK3, fontFace: FONT });
    slide.addShape("line", { x: cx + 0.45, y: cy + 0.46, w: w / 2 - 0.6, h: 0, line: { color: LINE, width: 0.6 } });
  });
  return y + half * 0.62;
}

// One block element -> pptx shapes. Returns the new y cursor.
function addBlock(slide, el, x, y, w) {
  if (el.classList.contains("pb-rows")) return addRows(slide, el, x, y, w);
  if (el.classList.contains("pb-cards")) return addCards(slide, el, x, y, w);
  if (el.classList.contains("pb-levers")) return addSteps(slide, el, x, y, w);
  if (el.classList.contains("pb-timeline")) return addTimeline(slide, el, x, y, w);
  if (el.classList.contains("pb-stats")) return addStats(slide, el, x, y, w);
  if (el.classList.contains("pb-arb")) return addArb(slide, el, x, y, w);
  if (el.classList.contains("pb-sowhat")) return addNote(slide, el, x, y, w);
  if (el.classList.contains("pb-toc")) return addToc(slide, el, x, y, w);
  if (el.classList.contains("pb-risks")) return addCards(slide, el, x, y, w);
  if (el.classList.contains("pb-list")) return addBullets(slide, el, x, y, w, el.tagName === "OL");
  if (el.classList.contains("pb-tbl")) return addTable(slide, el, x, y, w);
  if (el.classList.contains("pb-chart")) {
    const cap = txt(el.querySelector(".pb-chart-cap"));
    slide.addText(cap.toUpperCase(), { x, y, w, h: 0.22, fontSize: 8, color: INK3, charSpacing: 1.4, fontFace: FONT });
    // Rebuild the market bars as a native, editable pptx chart from the rendered SVG labels.
    const labels = all(el, "svg text").map((t) => txt(t));
    const cats = labels.filter((t) => /^\d{4}$/.test(t));
    const vals = labels.filter((t) => !/^\d{4}$/.test(t)).map((t) => parseFloat(t)).filter((n) => !isNaN(n));
    if (PPTX && cats.length && vals.length === cats.length) {
      try {
      slide.addChart(PPTX.ChartType.bar, [{ name: cap || "Market size", labels: cats, values: vals }], {
        x, y: y + 0.26, w, h: 1.9, barDir: "col", barGapWidthPct: 120, chartColors: [INK, "8FBF2E"], varyColors: true,
        showValue: true, dataLabelColor: INK, dataLabelFontSize: 9, dataLabelFontFace: FONT,
        showLegend: false, catAxisLabelColor: INK2, catAxisLabelFontSize: 9, catAxisLabelFontFace: FONT,
        valAxisHidden: true, valGridLine: { style: "none" }, catAxisLineShow: false, border: { pt: 0, color: PAPER },
      });
      } catch (e) { return y + 0.3; }
      return y + 2.3;
    }
    return y + 0.3;
  }
  if (el.classList.contains("pb-h3")) {
    slide.addText(txt(el).toUpperCase(), { x, y, w, h: 0.22, fontSize: 8.5, bold: true, color: INK3, charSpacing: 1.4, fontFace: FONT });
    return y + 0.3;
  }
  if (el.classList.contains("pb-fine")) {
    const t = txt(el);
    const h = 0.16 * lines(t, Math.round(w * 22));
    slide.addText(t, { x, y, w, h, fontSize: 7.5, color: INK3, fontFace: FONT, valign: "top", lineSpacingMultiple: 0.95 });
    return y + h + 0.12;
  }
  if (el.classList.contains("pb-prose")) {
    let cy = y;
    Array.from(el.children).forEach((c) => {
      const t = txt(c);
      if (!t) return;
      if (c.tagName === "H3") {
        slide.addText(t.toUpperCase(), { x, y: cy, w, h: 0.22, fontSize: 8.5, bold: true, color: INK3, charSpacing: 1.4, fontFace: FONT });
        cy += 0.28;
      } else if (c.tagName === "P") {
        const h = 0.19 * lines(t, Math.round(w * 15));
        slide.addText(t, { x, y: cy, w, h, fontSize: 9.5, color: INK2, fontFace: FONT, valign: "top", lineSpacingMultiple: 0.95 });
        cy += h + 0.16;
      } else {
        cy = addBlock(slide, c, x, cy, w);
      }
    });
    return cy;
  }
  if (el.classList.contains("pb-empty")) {
    slide.addText(txt(el), { x, y, w, h: 0.5, fontSize: 10, color: INK3, fontFace: FONT });
    return y + 0.6;
  }
  // Wrapper div: recurse into its children.
  let cy = y;
  Array.from(el.children).forEach((c) => { cy = addBlock(slide, c, x, cy, w); });
  return cy;
}

// pptxgenjs fetches remote images while writing the file, and a CORS failure there kills the whole export.
// So the cover is inlined as base64 up front; if that fails the slide simply keeps its dark background.
const toDataUrl = async (src) => {
  if (!src) return null;
  if (String(src).startsWith("data:")) return src;
  try {
    const res = await fetch(src, { mode: "cors", credentials: "omit" });
    if (!res.ok) return null;
    const blob = await res.blob();
    if (!blob.type.startsWith("image/")) return null;
    return await new Promise((resolve) => {
      const r = new FileReader();
      r.onload = () => resolve(r.result);
      r.onerror = () => resolve(null);
      r.readAsDataURL(blob);
    });
  } catch (e) { return null; }
};

function buildCover(slide, el, coverData) {
  slide.background = { color: "16202E" };
  if (coverData) {
    try {
      slide.addImage({ data: coverData, x: 0, y: 0, w: W, h: Hh, sizing: { type: "cover", w: W, h: Hh } });
      slide.addShape("rect", { x: 0, y: Hh * 0.42, w: W, h: Hh * 0.58, fill: { color: "0A111C", transparency: 22 } });
    } catch (e) { /* keep the flat background */ }
  }
  const ink = el.querySelector(".pb-cover-ink");
  slide.addText(txt(ink.querySelector(".pb-eyebrow")).toUpperCase(), { x: PADX, y: 4.05, w: W - PADX * 2, h: 0.24, fontSize: 9, color: "D7DEE8", charSpacing: 2, fontFace: FONT });
  slide.addText(txt(ink.querySelector("h1")), { x: PADX, y: 4.3, w: W - PADX * 2, h: 0.8, fontSize: 40, bold: true, color: "FFFFFF", fontFace: FONT });
  slide.addText(txt(ink.querySelector(".pb-cover-sub")), { x: PADX, y: 5.12, w: W - PADX * 2, h: 0.3, fontSize: 12, color: "E4E9F0", fontFace: FONT });
  const asks = all(ink, ".pb-ask");
  const aw = (W - PADX * 2) / Math.max(1, asks.length);
  asks.forEach((a, i) => {
    const ax = PADX + i * aw;
    slide.addShape("rect", { x: ax, y: 5.62, w: aw - 0.04, h: 1.05, fill: { color: "0B1420", transparency: 30 } });
    slide.addText(txt(a.querySelector("span")).toUpperCase(), { x: ax + 0.16, y: 5.72, w: aw - 0.3, h: 0.2, fontSize: 8, color: "C2CBD8", charSpacing: 1.6, fontFace: FONT });
    slide.addText(txt(a.querySelector("b")), { x: ax + 0.16, y: 5.94, w: aw - 0.3, h: 0.42, fontSize: 21, bold: true, color: ACCENT, fontFace: FONT });
    slide.addText(txt(a.querySelector("i")), { x: ax + 0.16, y: 6.38, w: aw - 0.3, h: 0.2, fontSize: 8, color: "C2CBD8", fontFace: FONT });
  });
  slide.addText(txt(ink.querySelector(".pb-cover-foot")).toUpperCase(), { x: PADX, y: 6.85, w: W - PADX * 2, h: 0.24, fontSize: 7.5, color: "AEB8C6", charSpacing: 0.8, fontFace: FONT });
}

export async function pptxFromDeck(container, filename, cover = []) {
  const PptxGenJS = await loadPptxGen();
  PPTX = PptxGenJS;
  const pptx = new PptxGenJS();
  pptx.defineLayout({ name: "PB16x9", width: W, height: Hh });
  pptx.layout = "PB16x9";
  pptx.author = "XYZ Ventures";
  pptx.title = filename.replace(/\.pptx$/i, "");

  const slides = Array.from(container.querySelectorAll("[data-pb-slide]"));
  if (!slides.length) throw new Error("nothing to export");
  const coverData = await toDataUrl(cover && cover[0]);

  slides.forEach((el) => {
    const slide = pptx.addSlide();
    if (el.classList.contains("pb-cover")) { buildCover(slide, el, coverData); return; }
    slide.background = { color: PAPER };
    const head = el.querySelector(".pb-head");
    slide.addText(txt(head && head.querySelector("h2")).toUpperCase(), { x: PADX, y: 0.42, w: 8, h: 0.3, fontSize: 13, bold: true, color: INK, charSpacing: 2, fontFace: FONT });
    const eyebrow = txt(head && head.querySelector("span"));
    if (eyebrow) slide.addText(eyebrow.toUpperCase(), { x: W - PADX - 4, y: 0.46, w: 4, h: 0.24, fontSize: 8.5, color: INK3, align: "right", charSpacing: 1.4, fontFace: FONT });
    slide.addShape("line", { x: PADX, y: 0.78, w: W - PADX * 2, h: 0, line: { color: INK, width: 1.5 } });

    let y = 0.98;
    const lead = txt(el.querySelector(".pb-lead"));
    if (lead) {
      const h = 0.34 * lines(lead, 78);
      slide.addText(lead, { x: PADX, y, w: W - PADX * 2, h, fontSize: 17, bold: true, color: INK, fontFace: FONT, valign: "top", lineSpacingMultiple: 0.95 });
      y += h + 0.18;
    }
    const bodyP = txt(el.querySelector(".pb-body"));
    if (bodyP) {
      const h = 0.2 * lines(bodyP, 150);
      slide.addText(bodyP, { x: PADX, y, w: W - PADX * 2, h, fontSize: 10, color: INK2, fontFace: FONT, valign: "top" });
      y += h + 0.16;
    }

    const canvas = el.querySelector(".pb-canvas");
    const two = canvas && canvas.querySelector(".pb-2col");
    if (two) {
      const [left, right] = Array.from(two.children);
      let ly = y, ry = y;
      if (left) Array.from(left.children).length ? Array.from(left.children).forEach((c) => { ly = addBlock(slide, c, PADX, ly, COL); }) : (ly = addBlock(slide, left, PADX, ly, COL));
      if (right) Array.from(right.children).length ? Array.from(right.children).forEach((c) => { ry = addBlock(slide, c, PADX + COL + 0.5, ry, COL); }) : (ry = addBlock(slide, right, PADX + COL + 0.5, ry, COL));
    } else if (canvas) {
      Array.from(canvas.children).forEach((c) => { y = addBlock(slide, c, PADX, y, W - PADX * 2); });
    }

    const foot = all(el, ".pb-foot span").map((s) => txt(s));
    slide.addShape("line", { x: PADX, y: 6.92, w: W - PADX * 2, h: 0, line: { color: LINE, width: 0.6 } });
    if (foot[0]) slide.addText(foot[0].toUpperCase(), { x: PADX, y: 7.0, w: 3.5, h: 0.24, fontSize: 7.5, color: INK3, charSpacing: 1, fontFace: FONT });
    if (foot[1]) slide.addText(foot[1].toUpperCase(), { x: W / 2 - 1.75, y: 7.0, w: 3.5, h: 0.24, fontSize: 7.5, color: INK3, align: "center", charSpacing: 1, fontFace: FONT });
    if (foot[2]) slide.addText(foot[2], { x: W - PADX - 1.5, y: 7.0, w: 1.5, h: 0.24, fontSize: 7.5, color: INK3, align: "right", fontFace: FONT });
  });

  await pptx.writeFile({ fileName: filename });
  return slides.length;
}
